import registrationStep from "../../../registrationStep";
import MinorsInParty from "./MinorsInParty";

export default registrationStep(MinorsInParty, "minors");



// WEBPACK FOOTER //
// ./src/registration/components/Minors/MinorsInParty/index.js